import { cn } from "@/lib/utils";

const lineClampStyle = (lines) => ({
  display: "-webkit-box",
  WebkitLineClamp: lines,
  WebkitBoxOrient: "vertical",
  overflow: "hidden",
});

const TextWithTooltip = ({ text, className, style }) => {
  const handleMouseEnter = (e) => {
    const el = e.currentTarget;
    const isClamped = el.scrollHeight > el.clientHeight + 1;
    const isTruncated = el.scrollWidth > el.clientWidth + 1;
    // Set native title only when actually overflowing — browser handles the rest
    el.title = isClamped || isTruncated ? (text ?? "") : "";
  };

  return (
    <p className={className} style={style} onMouseEnter={handleMouseEnter}>
      {text ?? "—"}
    </p>
  );
};

const TableText = ({
  title,
  subtitle,
  align = "left",
  titleClassName,
  subtitleClassName,
  maxWidth = "100%",
  multiline = false,
  maxLines,
}) => (
  <div className={cn(align === "right" && "text-right")} style={{ maxWidth }}>
    <TextWithTooltip
      text={title}
      className={cn(
        "text-sm font-medium leading-snug",
        !multiline && "truncate",
        titleClassName ?? "text-slate-900 dark:text-slate-100",
      )}
      style={multiline && maxLines ? lineClampStyle(maxLines) : undefined}
    />

    {subtitle != null && (
      <TextWithTooltip
        text={subtitle}
        className={cn(
          "mt-0.5 text-xs leading-snug",
          !multiline && "truncate",
          subtitleClassName ?? "text-slate-500 dark:text-slate.400",
        )}
        style={multiline && maxLines ? lineClampStyle(maxLines) : undefined}
      />
    )}
  </div>
);

export default TableText;
